import axios from "axios";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import AntdBreadcrumbs from "../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import MainconternLayout from "../../components/Layout/MainconternLayout";
import SucessModal from "../../components/Modal/SucessModal";

const SustainabilityPolicyCounter = () => {
  const {
    register,
    setValue,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const [success, setSuccess] = useState(false);
  const [editSuccess, setEditSuccess] = useState(false);
  const [count, setCount] = useState(0);
  const [id, setId] = useState("");

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}sustainability-policy-counter/sustainability-policy-counter-list`,
      )
      .then((res) => {
        setCount(res.data.count);
        setId(res.data.rows[0]._id);
        setValue("count", res?.data?.rows[0]?.count);
      });
  }, [setValue]);

  const onSubmit = (fields) => {
    if (count === 0) {
      axios
        .post(
          `${process.env.REACT_APP_API_URL}sustainability-policy-counter/sustainability-policy-counter-create`,
          fields,
        )
        .then((res) => {
          setSuccess(true);
        });
    } else if (count === 1) {
      axios
        .patch(
          `${process.env.REACT_APP_API_URL}sustainability-policy-counter/sustainability-policy-counter-update/${id}`,
          fields,
        )
        .then((res) => {
          setEditSuccess(true);
        });
    }
  };

  const breadcrumbsList = [
    {
      text: "Counter",
      link: "/counter-home",
    },
    { text: "Home", link: "" },
  ];

  return (
    <>
      <MainconternLayout
        header={
          <AntdBreadcrumbs
            className="healthsyMasterBreadCrumbs"
            breadcrumbsList={breadcrumbsList}
          />
        }
        footer={<></>}
      >
        <div className="healtharticle-container healthsyContainer">
          <form onSubmit={handleSubmit(onSubmit)} className="carr-dep-form">
            <div className="row car-dep-form">
              <div className="col-6">
                <label
                  className="car-dep-form-txt mb-2"
                  style={{ color: "#4B4853" }}
                  htmlFor=""
                >
                  Count <span className="star">*</span>
                </label>
                <input
                  className="form-control w-75"
                  type="number"
                  name=""
                  id="type"
                  {...register("count", { required: true })}
                  placeholder="Enter the Count"
                />
                {errors.count && (
                  <div className={`invalid-feedback d-block`}>
                    Please Enter Count
                  </div>
                )}
              </div>
            </div>

            <div className="car-dep-form-button m-0 pt-5">
              <button type="submit">SUBMIT</button>
            </div>
          </form>
        </div>
      </MainconternLayout>

      {success && (
        <SucessModal page={"/counter-home"} name="Count" post="Added" />
      )}

      {editSuccess && (
        <SucessModal page={"/counter-home"} name="Count" post="Updated" />
      )}
    </>
  );
};

export default SustainabilityPolicyCounter;
